import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, useMediaQuery } from '@mui/material'
import { anchorOrigin, transformOrigin } from '../../theme/styleConstants'
import { useContext } from 'react'
import { AppContext } from '../../context'
import { ActionType } from '../../context/AppContextReducer'
import { useSearchParams } from 'react-router-dom'
import { QUERY_PARAMS } from '../../constants'

enum OrderVendorBy {
  VENDOR_ID = 'vendorId',
  SORT_CODE = 'sortCode'
}

const VendorFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const mediumViewport = useMediaQuery('(max-width:1138px)')
  const { dispatch: reducerDispatch } = useContext(AppContext)

  const handleSortOrderChange = (event: SelectChangeEvent) => {
    const { value } = event.target
    reducerDispatch({ type: ActionType.SET_CURRENT_PAGE, currentPage: 1 })
    searchParams.set(QUERY_PARAMS.ORDER_BY, value)
    setSearchParams(searchParams)
  }

  const handleSortDirectionChange = (event: SelectChangeEvent) => {
    const { value } = event.target
    reducerDispatch({ type: ActionType.SET_CURRENT_PAGE, currentPage: 1 })
    searchParams.set(QUERY_PARAMS.ORDER_DIRECTION, value)
    setSearchParams(searchParams)
  }

  return (
    <Box display={'flex'} gap={2}>
      <FormControl>
        <InputLabel id="sortBy">Sort By:</InputLabel>
        <Select
          labelId="sortBy"
          id="sortBy"
          label={'Sort By:'}
          onChange={handleSortOrderChange}
          displayEmpty={true}
          value={searchParams.get(QUERY_PARAMS.ORDER_BY) || OrderVendorBy.VENDOR_ID}
          sx={{ width: mediumViewport ? 262 : 130 }}
          MenuProps={{
            anchorOrigin,
            transformOrigin,
            style: {
              maxHeight: 400
            }
          }}
        >
          <MenuItem value={OrderVendorBy.VENDOR_ID}>Vendor ID</MenuItem>
          <MenuItem value={OrderVendorBy.SORT_CODE}>Sort Code</MenuItem>
        </Select>
      </FormControl>

      <FormControl>
        <InputLabel id="sortDirection">Sort Direction:</InputLabel>
        <Select
          labelId="sortDirection"
          id="sortDirection"
          label={'Sort Direction:'}
          onChange={handleSortDirectionChange}
          displayEmpty={true}
          value={searchParams.get(QUERY_PARAMS.ORDER_DIRECTION) || 'DESC'}
          sx={{ width: mediumViewport ? 262 : 150 }}
          MenuProps={{
            anchorOrigin,
            transformOrigin,
            style: {
              maxHeight: 400
            }
          }}
        >
          <MenuItem value="ASC">ASC</MenuItem>
          <MenuItem value="DESC">DESC</MenuItem>
        </Select>
      </FormControl>
    </Box>
  )
}

export default VendorFilter
